import { render, staticRenderFns } from "./TableDatetimeItem.vue?vue&type=template&id=c7248788&scoped=true"
import script from "./TableDatetimeItem.vue?vue&type=script&lang=js"
export * from "./TableDatetimeItem.vue?vue&type=script&lang=js"
import style0 from "./TableDatetimeItem.vue?vue&type=style&index=0&id=c7248788&scoped=true&lang=css"
import style1 from "./TableDatetimeItem.vue?vue&type=style&index=1&id=c7248788&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7248788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7248788')) {
      api.createRecord('c7248788', component.options)
    } else {
      api.reload('c7248788', component.options)
    }
    module.hot.accept("./TableDatetimeItem.vue?vue&type=template&id=c7248788&scoped=true", function () {
      api.rerender('c7248788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/tableItems/TableDatetimeItem.vue"
export default component.exports